import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  TextField,
  Button,
  Typography,
  Autocomplete,
  FormControl,
  IconButton,
  Grid,
  FormControlLabel,
  Switch,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { ModalBox } from "../../../styles/ModalStyles";
import { getClienteHabilitado } from "../../http/actions/ClientesAction";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import ColorPickerComponent from "../../common/ColorPickerComponent";

const EditarConfiguracionCorreoModal = ({ open, onClose, onSubmit, configuracion }) => {
  const [clientes, setClientes] = useState([]);
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
  
  // Estados para las configuraciones
  const [colorPrimario, setColorPrimario] = useState("#ffa500");
  const [colorSecundario, setColorSecundario] = useState("#ffffff");
  const [mostrarTipoDocumento, setMostrarTipoDocumento] = useState(true);
  const [mostrarDescripcion, setMostrarDescripcion] = useState(true);
  const [mostrarFechaPublicacion, setMostrarFechaPublicacion] = useState(true);
  const [mostrarEstado, setMostrarEstado] = useState(true);
  const [mostrarUrlExterna, setMostrarUrlExterna] = useState(true);
  const [mostrarClasificaciones, setMostrarClasificaciones] = useState(false);
  const [mostrarRubros, setMostrarRubros] = useState(false);
  const [separarNormativasActualizadas, setSepararNormativasActualizadas] = useState(false);
  const [soloEstadoMayorAUno, setSoloEstadoMayorAUno] = useState(true);
  const [encabezadoPersonalizado, setEncabezadoPersonalizado] = useState("");
  const [piePersonalizado, setPiePersonalizado] = useState("");
  const [formatoFecha, setFormatoFecha] = useState("dd/MM/yyyy");
  const [habilitado, setHabilitado] = useState(true);


  useEffect(() => {
    fetchClientes();
  }, []);

  useEffect(() => {
    if (configuracion && clientes.length > 0) {
      setColorPrimario(configuracion.colorPrimario);
      setColorSecundario(configuracion.colorSecundario);
      setMostrarTipoDocumento(configuracion.mostrarTipoDocumento);
      setMostrarDescripcion(configuracion.mostrarDescripcion);
      setMostrarFechaPublicacion(configuracion.mostrarFechaPublicacion);
      setMostrarEstado(configuracion.mostrarEstado);
      setMostrarUrlExterna(configuracion.mostrarUrlExterna);
      setMostrarClasificaciones(configuracion.mostrarClasificaciones);
      setMostrarRubros(configuracion.mostrarRubros);
      setSepararNormativasActualizadas(configuracion.separarNormativasActualizadas);
      setSoloEstadoMayorAUno(configuracion.soloEstadoMayorAUno);
      setEncabezadoPersonalizado(configuracion.encabezadoPersonalizado || "");
      setPiePersonalizado(configuracion.piePersonalizado || "");
      setFormatoFecha(configuracion.formatoFecha);
      setHabilitado(configuracion.habilitado);

      const clienteCorrespondiente = clientes.find(c => c.id === configuracion.idCliente);
      setClienteSeleccionado(clienteCorrespondiente || null);
    }
  }, [configuracion, clientes]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      ...configuracion,
      idCliente: clienteSeleccionado ? clienteSeleccionado.id : null,
      colorPrimario,
      colorSecundario,
      mostrarTipoDocumento,
      mostrarDescripcion,
      mostrarFechaPublicacion,
      mostrarEstado,
      mostrarUrlExterna,
      mostrarClasificaciones,
      mostrarRubros,
      separarNormativasActualizadas,
      soloEstadoMayorAUno,
      encabezadoPersonalizado,
      piePersonalizado,
      formatoFecha,
      habilitado
    });
  };

  const fetchClientes = () => {
    getClienteHabilitado(localStorage.getItem("token"))
      .then((response) => {
        setClientes(response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalBox sx={{ width: '90%', maxWidth: 800, maxHeight: '90vh', overflow: 'auto' }}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        
        <Typography variant='h6' sx={{ mb: 3 }}>Editar Configuración de Correo</Typography>
        
        <form onSubmit={handleSubmit}>
          {/* Cliente */}
          <FormControl fullWidth sx={{ mb: 2 }}>
            <Autocomplete
              noOptionsText="No hay opciones disponibles"
              options={clientes}
              getOptionLabel={(option) => option.nombre || ''}
              renderInput={(params) => (
                <TextField {...params} label="Cliente *" />
              )}
              value={clienteSeleccionado}
              onChange={(event, newValue) => {
                setClienteSeleccionado(newValue);
              }}
              isOptionEqualToValue={(option, value) => option.id === value.id}
            />
          </FormControl>

          {/* Configuración de Colores */}
          <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Configuración de Colores</Typography>
           </AccordionSummary>
           <AccordionDetails>
             <Grid container spacing={2}>
               <Grid item xs={12} sm={6}>
                 <ColorPickerComponent
                   color={colorPrimario}
                   onChange={(color) => setColorPrimario(color)}
                   label="Color Criticidad Baja"
                 />
               </Grid>
             </Grid>
           </AccordionDetails>
         </Accordion>

         {/* Configuración de Columnas Básicas */}
         <Accordion>
           <AccordionSummary expandIcon={<ExpandMoreIcon />}>
             <Typography variant="h6">Columnas Básicas</Typography>
           </AccordionSummary>
           <AccordionDetails>
             <Grid container spacing={2}>
               <Grid item xs={12} sm={6}>
                 <FormControlLabel
                   control={
                     <Switch
                       checked={mostrarTipoDocumento}
                       onChange={(e) => setMostrarTipoDocumento(e.target.checked)}
                     />
                   }
                   label="Mostrar Tipo Documento"
                 />
               </Grid>
               <Grid item xs={12} sm={6}>
                 <FormControlLabel
                   control={
                     <Switch
                       checked={mostrarDescripcion}
                       onChange={(e) => setMostrarDescripcion(e.target.checked)}
                     />
                   }
                   label="Mostrar Descripción"
                 />
               </Grid>
               <Grid item xs={12} sm={6}>
                 <FormControlLabel
                   control={
                     <Switch
                       checked={mostrarFechaPublicacion}
                       onChange={(e) => setMostrarFechaPublicacion(e.target.checked)}
                     />
                   }
                   label="Mostrar Fecha Publicación"
                 />
               </Grid>
               <Grid item xs={12} sm={6}>
                 <FormControlLabel
                   control={
                     <Switch
                       checked={mostrarEstado}
                       onChange={(e) => setMostrarEstado(e.target.checked)}
                     />
                   }
                   label="Mostrar Estado"
                 />
               </Grid>
               <Grid item xs={12} sm={6}>
                 <FormControlLabel
                   control={
                     <Switch
                       checked={mostrarUrlExterna}
                       onChange={(e) => setMostrarUrlExterna(e.target.checked)}
                     />
                   }
                   label="Mostrar URL Externa"
                 />
               </Grid>
             </Grid>
           </AccordionDetails>
         </Accordion>

         {/* Configuración de Columnas Adicionales */}
         <Accordion>
           <AccordionSummary expandIcon={<ExpandMoreIcon />}>
             <Typography variant="h6">Columnas Adicionales</Typography>
           </AccordionSummary>
           <AccordionDetails>
             <Grid container spacing={2}>
               <Grid item xs={12} sm={6}>
                 <FormControlLabel
                   control={
                     <Switch
                       checked={mostrarClasificaciones}
                       onChange={(e) => setMostrarClasificaciones(e.target.checked)}
                     />
                   }
                   label="Mostrar Clasificaciones"
                 />
               </Grid>
               <Grid item xs={12} sm={6}>
                 <FormControlLabel
                   control={
                     <Switch
                       checked={mostrarRubros}
                       onChange={(e) => setMostrarRubros(e.target.checked)}
                     />
                   }
                   label="Mostrar Rubros"
                 />
               </Grid>
             </Grid>
           </AccordionDetails>
         </Accordion>

         {/* Configuración de Correo */}
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6">Configuración de Correo</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Encabezado Personalizado"
                    multiline
                    rows={3}
                    value={encabezadoPersonalizado}
                    onChange={(e) => setEncabezadoPersonalizado(e.target.value)}
                    placeholder="Texto que aparecerá en el encabezado del correo"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Pie Personalizado"
                    multiline
                    rows={3}
                    value={piePersonalizado}
                    onChange={(e) => setPiePersonalizado(e.target.value)}
                    placeholder="Texto que aparecerá en el pie del correo"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={separarNormativasActualizadas}
                        onChange={(e) => setSepararNormativasActualizadas(e.target.checked)}
                      />
                    }
                    label="Separar Normativas Actualizadas"
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>

         {/* Estado */}
         <Box sx={{ mt: 2 }}>
           <FormControlLabel
             control={
               <Switch
                 checked={habilitado}
                 onChange={(e) => setHabilitado(e.target.checked)}
                 color="primary"
               />
             }
             label={habilitado ? "Habilitado" : "Deshabilitado"}
           />
         </Box>

         <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
           <Button 
             type="submit" 
             variant="contained" 
             color="primary"
             disabled={!clienteSeleccionado}
           >
             Guardar Cambios
           </Button>
           <Button onClick={onClose} variant="contained" color="error">
             Cancelar
           </Button>
         </Box>
       </form>
     </ModalBox>
   </Modal>
 );
};

export default EditarConfiguracionCorreoModal;